var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-assoc-drawer research-data-table-wrapper" },
    [
      _vm.drawerStatusLabel
        ? _c("p", { staticClass: "vks-assoc-meta" }, [
            _vm._v(_vm._s(_vm.drawerStatusLabel)),
          ])
        : _vm._e(),
      _vm.loading && !_vm.hideLoadingStatus
        ? _c("div", { staticClass: "vks-assoc-status" }, [
            _vm._v("Loading associations…"),
          ])
        : _vm.error
        ? _c(
            "div",
            { staticClass: "vks-assoc-error", attrs: { role: "alert" } },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : !_vm.rows.length
        ? _c("div", { staticClass: "vks-assoc-status" }, [
            _vm._v(" No associations returned for this locus. "),
          ])
        : [
            _c(
              "section",
              {
                staticClass: "vks-drawer-section vks-drawer-section--controls",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "vks-ui-tabs",
                    attrs: {
                      role: "tablist",
                      "aria-label": "Associations controls",
                    },
                  },
                  _vm._l(_vm.controlTabs, function (tab) {
                    return _c(
                      "button",
                      {
                        key: tab.id,
                        staticClass: "vks-ui-tab",
                        class: { "is-active": _vm.activeControlTab === tab.id },
                        attrs: {
                          id: `vks-assoc-tab-${tab.id}`,
                          type: "button",
                          role: "tab",
                          "aria-selected":
                            _vm.activeControlTab === tab.id ? "true" : "false",
                          "aria-controls": `vks-assoc-panel-${tab.id}`,
                        },
                        on: {
                          click: function ($event) {
                            _vm.activeControlTab = tab.id
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(tab.label) + " ")]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeControlTab === "pvalue-ld",
                        expression: "activeControlTab === 'pvalue-ld'",
                      },
                    ],
                    staticClass: "vks-ui-tab-panel",
                    attrs: {
                      id: "vks-assoc-panel-pvalue-ld",
                      role: "tabpanel",
                      "aria-labelledby": "vks-assoc-tab-pvalue-ld",
                    },
                  },
                  [
                    _c("VariantSifterAssociationsLdPlot", {
                      attrs: {
                        rows: _vm.filteredRows,
                        "primary-ancestry": _vm.primaryAncestry,
                        "selected-ancestries": _vm.selectedAncestries,
                        "selected-phenotypes": _vm.selectedPhenotypes,
                        "search-session": _vm.searchSession,
                        "plot-overlays-state": _vm.plotOverlaysState,
                        "plot-markers": _vm.plotMarkers,
                        layout: "stack",
                        utils: _vm.utils,
                      },
                      on: {
                        "toggle-star-variant": function ($event) {
                          return _vm.$emit("toggle-star-variant", $event)
                        },
                        "set-reference-variant": function ($event) {
                          return _vm.$emit("set-reference-variant", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeControlTab === "ancestries",
                        expression: "activeControlTab === 'ancestries'",
                      },
                    ],
                    staticClass: "vks-ui-tab-panel",
                    attrs: {
                      id: "vks-assoc-panel-ancestries",
                      role: "tabpanel",
                      "aria-labelledby": "vks-assoc-tab-ancestries",
                    },
                  },
                  [
                    _c("p", { staticClass: "vks-ui-hint" }, [
                      _vm._v(
                        " Select an ancestry to load additional associations. "
                      ),
                    ]),
                    _c("VariantSifterAncestryBubbles", {
                      attrs: {
                        bubbles: _vm.ancestryBubbles,
                        groups: _vm.ancestryBubbleGroups,
                        "primary-ancestry": _vm.primaryAncestry,
                        "selected-ancestries": _vm.selectedAncestries,
                        "series-loading": _vm.ancestrySeriesLoading,
                        loading: _vm.ancestryAvailabilityLoading,
                        error: _vm.ancestryAvailabilityError,
                      },
                      on: {
                        "toggle-ancestry": function ($event) {
                          return _vm.$emit("toggle-ancestry", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeControlTab === "filters",
                        expression: "activeControlTab === 'filters'",
                      },
                    ],
                    staticClass: "vks-ui-tab-panel",
                    attrs: {
                      id: "vks-assoc-panel-filters",
                      role: "tabpanel",
                      "aria-labelledby": "vks-assoc-tab-filters",
                    },
                  },
                  [
                    _c("VariantSifterAssociationsFilters", {
                      attrs: {
                        rows: _vm.rows,
                        "filters-index": _vm.filtersIndex,
                        "include-project": _vm.showProjectColumn,
                        "include-phenotype": _vm.showPhenotypeColumn,
                      },
                      on: {
                        "update:filtersIndex": function ($event) {
                          return _vm.$emit("update:filtersIndex", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "section",
              { staticClass: "vks-drawer-section vks-drawer-section--table" },
              [
                _c(
                  "div",
                  { staticClass: "vks-assoc-table-section" },
                  [
                    _c("VariantSifterTableSettings", {
                      attrs: {
                        "per-page": Number(_vm.perPageNumber),
                        columns: _vm.mappedTopRows,
                        "visible-columns": _vm.visibleColumns,
                      },
                      on: {
                        "update:perPage": _vm.onPerPageUpdate,
                        "export-csv": _vm.exportCsv,
                        "export-json": _vm.exportJson,
                        "update:columnVisible": _vm.onColumnVisibleUpdate,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "before",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "vks-data-table-view-total" },
                                [
                                  _vm._v(
                                    " Total rows: " +
                                      _vm._s(
                                        _vm.displayRows.length.toLocaleString()
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _c(
                      "div",
                      { staticClass: "vks-assoc-table-block" },
                      [
                        _c("div", { staticClass: "vks-assoc-table-wrap" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-sm research-data-table vks-associations-table",
                              attrs: { cellpadding: "0", cellspacing: "0" },
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm.starColumn
                                      ? _c(
                                          "th",
                                          [
                                            _c("b-icon", {
                                              staticStyle: {
                                                color: "#ffcc00",
                                                cursor: "pointer",
                                              },
                                              attrs: {
                                                icon: _vm.showStarredOnly
                                                  ? "star-fill"
                                                  : "star",
                                              },
                                              on: {
                                                click: _vm.toggleStarredOnly,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      _vm.visibleTopRows,
                                      function (column) {
                                        return _c(
                                          "th",
                                          {
                                            key: column,
                                            staticClass:
                                              "byor-tooltip sortable-th",
                                            class: _vm.getColumnId(column),
                                            on: {
                                              click: function ($event) {
                                                return _vm.applySorting(column)
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(column)),
                                            ]),
                                            _vm.activeTableFormat[
                                              "tool tips"
                                            ]?.[column]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "tooltiptext",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.activeTableFormat[
                                                          "tool tips"
                                                        ][column]
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(
                                    _vm.pagedRows,
                                    function (row, rowIndex) {
                                      return [
                                        _c(
                                          "tr",
                                          {
                                            key:
                                              row["Variant ID"] +
                                              "-" +
                                              rowIndex,
                                          },
                                          [
                                            _vm.starColumn
                                              ? _c(
                                                  "td",
                                                  [
                                                    _c("b-icon", {
                                                      style: {
                                                        color: _vm.isStarred(
                                                          row
                                                        )
                                                          ? "#ffcc00"
                                                          : "#aaaaaa",
                                                        cursor: "pointer",
                                                      },
                                                      attrs: {
                                                        icon: _vm.isStarred(row)
                                                          ? "star-fill"
                                                          : "star",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleStar(
                                                            row
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._l(
                                              _vm.visibleTopRows,
                                              function (column) {
                                                return _c(
                                                  "td",
                                                  {
                                                    key: `${row["Variant ID"]}-${rowIndex}-${column}`,
                                                    class:
                                                      _vm.getColumnId(column),
                                                  },
                                                  [
                                                    _vm.isExpandableMappingColumn(
                                                      column
                                                    ) &&
                                                    _vm.hasMappingGroup(
                                                      row,
                                                      column
                                                    )
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "vks-mapping-ppa-button",
                                                            class: {
                                                              "is-open":
                                                                _vm.isMappingExpanded(
                                                                  row,
                                                                  column
                                                                ),
                                                            },
                                                            style: {
                                                              color:
                                                                _vm.mappingColumnColor(
                                                                  column
                                                                ),
                                                            },
                                                            attrs: {
                                                              type: "button",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.toggleMappingExpand(
                                                                  row,
                                                                  column
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.formatExpandableValue(
                                                                    row,
                                                                    column
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.formatCell(
                                                                row,
                                                                column
                                                              )
                                                            ),
                                                          },
                                                        }),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm.expandedPanelsForRow(row).length
                                          ? _c(
                                              "tr",
                                              {
                                                key: `${row["Variant ID"]}-${rowIndex}-details`,
                                                staticClass:
                                                  "vks-mapping-details-row",
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan:
                                                        _vm.mappingDetailColspan,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "vks-mapping-details-stack",
                                                      },
                                                      _vm._l(
                                                        _vm.expandedPanelsForRow(
                                                          row
                                                        ),
                                                        function (panel) {
                                                          return _c(
                                                            "VariantSifterMappingRowDetails",
                                                            {
                                                              key: panel.groupId,
                                                              attrs: {
                                                                details:
                                                                  panel.details,
                                                                "group-id":
                                                                  panel.groupId,
                                                                title:
                                                                  panel.title,
                                                                utils:
                                                                  _vm.utils,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                        _vm.perPageNumber !== "0" && _vm.perPageNumber !== 0
                          ? _c("b-pagination", {
                              staticClass:
                                "pagination-sm justify-content-center vks-assoc-pagination",
                              attrs: {
                                "total-rows": _vm.displayRows.length,
                                "per-page": Number(_vm.perPageNumber),
                              },
                              model: {
                                value: _vm.currentPage,
                                callback: function ($$v) {
                                  _vm.currentPage = $$v
                                },
                                expression: "currentPage",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }